<script>
import {
  CollectionCardElementMixin,
} from "%/dynamic-component-editor/standard-components/base-collection-card/collection-card-element-mixin";
import UrlElement from "%/dynamic-component-editor/standard-elements/url-element/UrlElement.vue";
import { useGeneralStore } from "%/dynamic-component-editor/stores/general-store";

export default {
  name: "CollectionDescription",
  elementPanelSettings: {
    displayName: "Collection Description",
    displayIcon: "text-alt",
    elementType: "element",
    elementGroup: "collectionElements",
  },
  extends: UrlElement,
  mixins: [CollectionCardElementMixin],
  computed: {
    label() {
      return this.entity.description;
    },
    computedHref() {
      return useGeneralStore().getRelativeHref(`/collection-items/${this.entity.collectionId}`);
    },
    shouldShowLink() {
      return !!this.label;
    },
  },
};
</script>
